import React from "react";
import "./style/SocialMedie.css";

const SocialMedie = ({ linkPath, icon, theme, type }) => {
  return (
    <a
      href={linkPath}
      target="_blank"
      aria-label="Social media"
      className={`ch-social-meadia ch-social-meadia--${theme} ch-social-meadia--${type}`}
      rel="noreferrer"
    >
      {icon}
    </a>
  );
};

export default SocialMedie;
